/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form2";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content1";
import {
  Get_All_Catagory,
  Service_By_Catagory,
} from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import toast from "react-hot-toast";
import { Update_Service_By_Group_Id } from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import { Trash2 } from "lucide-react";
import { Get_Service_By_Group_Id_For_Edit_Update } from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import Table from "../../../../Components/ExtraComponents/Tables/FullDataTable";
import Swal from "sweetalert2";

const AddStrategy = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const AdminToken = JSON.parse(localStorage.getItem("user_details")).token;
  const [SerachService, setSerachService] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [GetAllSgments, setGetAllSgments] = useState({
    loading: true,
    data: [],
  });
  const [allServices, setAllServices] = useState({ loading: true, data: [] });
  const [groupServiceInfo, setGroupServiceInfo] = useState({
    loading: true,
    data: [],
  });
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectAllFiltered, setSelectAllFiltered] = useState(false);
  const [state, setstate] = useState([]);
  const [groupname, setGroupname] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [tableSearch, setTableSearch] = useState("");
  const filteredTableData = selectedServices.filter((service) =>
    service.name.toLowerCase().includes(tableSearch.toLowerCase())
  );

  const formik = useFormik({
    initialValues: {
      groupname: "",
      segment: false,
    },
    touched: {
      groupname: false,
      email: false,
    },
    validate: (values) => {
      const errors = {};

      return errors;
    },

    onSubmit: async (values) => {
      if (!groupname) {
        toast.error("Please Select Group Name ");
      }
      let checkValid = true;

      selectedServices &&
        selectedServices.map((item) => {
          if (item.lotSize !== 1) {
            if (item.group_qty % item.lotSize !== 0) {
              toast.error(`Please Enter Valid Lot Size Inside ${item.name}`);
              checkValid = false;
              return;
            }
            return;
          }

          return;
        });

      if (checkValid) {
        await dispatch(
          Update_Service_By_Group_Id({
            groupdetails: { name: groupname, id: id },
            services_id: selectedServices,
          })
        ).then((response) => {
          if (response.payload.status) {
            toast.success(response.payload.msg);
            setTimeout(() => {
              navigate("/admin/groupservices");
            }, 1000);
          } else {
            toast.error(response.payload.msg);
          }
        });
      }
    },
  });

  useEffect(() => {
    data();
    getservice();
    setSerachService("");
    setSelectAllFiltered(false);
  }, []);

  useEffect(() => {
    data2();
  }, [id]);

  useEffect(() => {
    if (groupServiceInfo.data[0] !== undefined) {
      formik.setFieldValue(
        "groupname",
        groupServiceInfo.data && groupServiceInfo.data[0].group_name
      );
    }
  }, [groupServiceInfo.data]);

  useEffect(() => {
    filterFunction();
  }, [SerachService]);

  const data2 = async () => {
    let arr = [];
    let arr1 = [];

    await dispatch(Get_Service_By_Group_Id_For_Edit_Update({ _id: id }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          response.data &&
            response.data.Service_name_get.map((item1) => {
              response.data &&
                response.data.group_name.map((item) => {
                  setGroupname(item.name);
                  arr.push({
                    group_name: item.name,
                    name: item1.ServiceResult.name,
                    instrumenttype: item1.ServiceResult.instrumenttype,

                    segment: item1.catagory.name,
                    segment_name: item1.catagory.category,
                    group_qty: item1.group_qty,
                    id: item1._id,
                  });
                });
            });

          response.data &&
            response.data.Service_name_get.map((item1) => {
              response.data &&
                response.data.group_name.map((item) => {
                  arr1.push({
                    service_id: item1.ServiceResult._id,
                    name: item1.ServiceResult.name,
                    segment: item1.catagory.category,
                    group_qty: item1.group_qty,
                    lotSize: item1.ServiceResult.lotSize,
                    instrumenttype: item1.ServiceResult.instrumenttype,
                    product_type: item1.product_type,
                  });
                });
            });
          setSelectedServices(arr1);

          setGroupServiceInfo({
            loading: false,
            data: arr,
          });
        }
      });
  };

  const InputGroupQty = (event, id, servicename, segement, qty, lotSize) => {
    const numericValue = event.target.value.replace(/[^0-9]/g, "");

    if (parseInt(event.target.value) < 0) {
      toast.error("no negetive allow");
      event.target.value = 0;
      return;
    } else {
      // if (parseInt(event.target.value) < 0) {

      const updatedQty = event.target.value === "" ? qty : numericValue;

      // Check if the selected service already exists in selectedServices
      const existingServiceIndex = selectedServices.findIndex(
        (item) => item.service_id === id
      );

      if (existingServiceIndex !== -1) {
        // Update quantity if the service already exists
        const updatedSelectedServices = [...selectedServices];
        updatedSelectedServices[existingServiceIndex].group_qty =
          parseInt(updatedQty);
        setSelectedServices(updatedSelectedServices);
      } else {
        // Add the new service to selectedServices
        setSelectedServices((prevServices) => [
          ...prevServices,
          {
            service_id: id,
            name: servicename,
            segment: segement,
            group_qty: parseInt(updatedQty),
            test: event.target.value,
          },
        ]);
      }
    }

    // }
    // else {
    //     alert("Negetive/Decimal/Character/Empty Field Not Allow")
    //     // event.target.value = ''
    //     return
    //     // }
    // }
  };

  const remoeveService = (id) => {
    let test = selectedServices.filter((item) => {
      return item.service_id !== id;
    });

    let checkboxes = document.querySelectorAll(`#service-${id}`);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    setSelectedServices(test);
  };

  const getservice = async () => {
    await dispatch(Get_All_Catagory())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setGetAllSgments({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  const fields = [];

  const data = async () => {
    setAllServices({
      loading: false,
      data: [],
    });
    await dispatch(
      Service_By_Catagory({ category: "6878f8d077603ec4430d04ed" })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllServices({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  const filterFunction = async () => {
    const search = SerachService.toLowerCase().trim();

    if (search === "") {
      setstate([]);
      return;
    }

    const filteredData = allServices.data.filter((item) =>
      item.name.toLowerCase().startsWith(search)
    );

    setstate(filteredData);
  };

  const columns = [
    {
      name: "Service Name",
      selector: (row) => row.name,
      sortable: true,
    },
    // {
    //   name: "Lot Size",
    //   selector: (row) => row.lotSize,
    //   sortable: true,
    // },
    // {
    //   name: "Qty",
    //   cell: (row) => (
    //     <input
    //       type="number"
    //       style={{ width: "80px", fontSize: "0.8rem", padding: "4px" }}
    //       className="form-control"
    //       placeholder="Enter Qty"
    //       onChange={(e) =>
    //         InputGroupQty(
    //           e,
    //           row.service_id,
    //           row.name,
    //           row.segment,
    //           row.group_qty,
    //           row.lotSize
    //         )
    //       }
    //       min={0}
    //       defaultValue={row.group_qty ? row.group_qty : 0}
    //     />
    //   ),
    // },
    {
      name: "Remove",
      cell: (row) => (
        <span
          className="text-danger"
          style={{ cursor: "pointer" }}
          onClick={() => {
            Swal.fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, delete it!",
            }).then((result) => {
              if (result.isConfirmed) {
                remoeveService(row.service_id);
                Swal.fire(
                  "Deleted!",
                  "The service has been removed.",
                  "success"
                );
              }
            });
          }}
        >
          <Trash2 />
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getExchangeByServiceName = (name) => {
    if (!name) return null;
    if (name.endsWith("USD")) return "CoinDCX";
    if (name.endsWith("INR")) return "Coinswitch-INR";
    return null;
  };


  return (
    <>
      <Content
        Page_title="Edit Group"
        button_title="Back"
        route="/admin/groupservices"
        additional_field={
          <div>
            <h6 className="  mb-3">Select Services And Quantity</h6>
            <div className="mb-3 col-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search Table ..."
                value={tableSearch}
                onChange={(e) => setTableSearch(e.target.value)}
              />
            </div>
            <div className="react-bootstrap-table">
              <Table
                columns={columns}
                data={filteredTableData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
          </div>
        }
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Edit Group"
          title="addstrategy"
          additional_field={
            <>
              <div className="row g-3">
                <div className="col-md-6 px-2 ">
                  <label>Group Name *</label>
                  <input
                    type="test"
                    className="form-control"
                    placeholder="Group name"
                    onChange={(e) => {
                      setGroupname(e.target.value);
                    }}
                    value={groupname}
                  />
                </div>

                <div className="col-md-6 ">
                  <label>Seach *</label>
                  <input
                    type="test"
                    className="form-control"
                    placeholder="Search ..."
                    onChange={(e) => {
                      setSerachService(e.target.value);
                    }}
                    value={SerachService}
                  />
                </div>

                <div
                  className="col-lg-12"
                  style={{
                    overflowY: state.length > 0 ? "auto" : "hidden",
                    overflowX: "hidden",
                    height: state.length > 0 ? "50vh" : "auto",
                  }}
                >
                  {state.length > 0 && (
                    <div className="mb-3 row">
                      <div className="col-lg-12">
                        <div className="row mt-4">
                          <>
                            {/* ✅ Select All Checkbox */}
                            <div className="col-md-4 mb-2">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="selectall"
                                  checked={selectAllFiltered}
                                  onChange={() => {
                                    if (state.length === 0) return;

                                    const firstExchange = getExchangeByServiceName(state[0].name);

                                    const mixedExchange = state.some(
                                      (s) =>
                                        getExchangeByServiceName(s.name) !== firstExchange
                                    );

                                    if (mixedExchange) {
                                      toast.error(
                                        "Select All Are not allowed (USD and INR not allowed in one group)"
                                      );
                                      return;
                                    }

                                    if (!selectAllFiltered) {
                                      const first30 = state.slice(0, 30).map((service) => ({
                                        service_id: service._id,
                                        name: service.name,
                                        segment: service.category?.name || "N/A",
                                        group_qty: 0,
                                        lotSize: service.lotSize,
                                        product_type:
                                          service.instrumenttype === "OPTSTK" ? 1 : 2,
                                      }));
                                      setSelectedServices(first30);
                                      setSelectAllFiltered(true);
                                    } else {
                                      setSelectedServices([]);
                                      setSelectAllFiltered(false);
                                    }
                                  }}
                                />

                                <label
                                  className="ms-1 form-check-label"
                                  htmlFor="selectall"
                                >
                                  Select All
                                </label>
                              </div>
                            </div>

                            {/* ✅ Individual Checkboxes */}
                            {state.map((service) => (
                              <div key={service._id} className="col-md-4 mb-2">
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`service-${service._id}`}
                                    value={service._id}
                                    checked={selectedServices.some(
                                      (s) => s.service_id === service._id
                                    )}
                                    onChange={(e) => {
                                      const isChecked = e.target.checked;
                                      const currentExchange = getExchangeByServiceName(service.name);

                                      const existingExchange =
                                        selectedServices.length > 0
                                          ? getExchangeByServiceName(selectedServices[0].name)
                                          : null;

                                      // ❌ BLOCK MIXED EXCHANGE
                                      if (
                                        isChecked &&
                                        existingExchange &&
                                        currentExchange !== existingExchange
                                      ) {
                                        toast.error(
                                          "USD And INR both services are not alloed in one Group"
                                        );
                                        e.target.checked = false;
                                        return;
                                      }

                                      setSelectedServices((prev) => {
                                        // max 30 rule
                                        if (
                                          isChecked &&
                                          !prev.some((p) => p.service_id === service._id) &&
                                          prev.length >= 30
                                        ) {
                                          toast.error("You can select a maximum of 30 items only!");
                                          e.target.checked = false;
                                          return prev;
                                        }

                                        if (isChecked) {
                                          return [
                                            ...prev,
                                            {
                                              service_id: service._id,
                                              name: service.name,
                                              segment: service.category?.name || "N/A",
                                              group_qty: 0,
                                              lotSize: service.lotSize,
                                              product_type:
                                                service.instrumenttype === "OPTSTK" ? 1 : 2,
                                            },
                                          ];
                                        } else {
                                          return prev.filter(
                                            (p) => p.service_id !== service._id
                                          );
                                        }
                                      });
                                    }}
                                  />

                                  <label
                                    className="ms-1 form-check-label"
                                    htmlFor={`service-${service._id}`}
                                  >
                                    {service.name}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          }
        />
      </Content>
    </>
  );
};

export default AddStrategy;
